<template>
    <v-row v-if="event" class="calendar-event" no-gutters>
        <v-col cols="2" lg="1" align="center">
            <div class="calendar-event-color" :style="`background-color: ${event.event.color}`" />
        </v-col>
        <v-hover v-slot="{ hover }">
            <v-col cols="10" lg="11" class="p-relative">
                <div class="calendar-event-name text-truncate">{{ event.event.versus }}</div>
                <div class="calendar-event-info text-truncate">
                    {{ $t('common.competence') }}
                </div>
                <div v-if="hover" class="calendar-event-actions">
                    <button-tooltip @click="$emit('click:show')" fab text x-small
                        :tooltip="$t('tooltips.edit_competence')">
                        <v-icon>$edit</v-icon>
                    </button-tooltip>
                    <button-tooltip @click="$emit('click:delete')" fab text x-small
                        :tooltip="$t('tooltips.delete_competence')">
                        <v-icon color="error">mdi-delete</v-icon>
                    </button-tooltip>
                </div>
            </v-col>
        </v-hover>
    </v-row>
</template>

<script>
import ButtonTooltip from "@/components/common/ButtonTooltip";
export default {
    name: "CompetenceEvent",
    components: { ButtonTooltip },
    props: {
        event: {
            type: Object,
            default: null,
        },
    },
}
</script>

<style scoped>
.calendar-event {
    border-bottom: 1px solid #D9D9D9;
}

.calendar-event-color {
    border-radius: 11px;
    height: 21px;
    width: 6px;
}

.calendar-event-name {
    font-weight: 300;
    font-size: 12px;
    line-height: 12px;
    color: #03342C;
}

.calendar-event-info {
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    color: #03342C;
}

.calendar-event-actions {
    position: absolute;
    right: 0;
    top: -8px;
    background-color: #FFFFFF;
}
</style>